import { Component } from '@angular/core';
import { MetforminComponent } from '@consultation-upsells/metformin/metformin.component';

@Component({
  selector: 'app-metformin-peptide',
  imports: [MetforminComponent],
  templateUrl: './metformin-peptide.component.html',
  styleUrls: ['./metformin-peptide.component.scss'],
})
export class MetforminPeptideComponent {}
